var map = {
	"./audio-placeholder": 556,
	"./audio-placeholder.png": 556,
	"./avatar-missing": 473,
	"./avatar-missing.png": 473,
	"./avatar-missing.svg": 681,
	"./header-missing": 498,
	"./header-missing.png": 498,
	"./soapbox-logo": 499,
	"./soapbox-logo-white": 500,
	"./soapbox-logo-white.svg": 500,
	"./soapbox-logo.svg": 499,
	"./video-placeholder": 557,
	"./video-placeholder.png": 557,
	"./void": 558,
	"./void.png": 558,
	"./web-push/web-push-icon_expand": 587,
	"./web-push/web-push-icon_expand.png": 587,
	"./web-push/web-push-icon_favourite": 588,
	"./web-push/web-push-icon_favourite.png": 588,
	"./web-push/web-push-icon_reblog": 589,
	"./web-push/web-push-icon_reblog.png": 589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;